module.exports = __webpack_public_path__ + "static/media/active_synthesized_audio.2a22eab6.svg";